import React from 'react'
import { useNavigate, Route, Routes } from 'react-router-dom'
import PropTypes from 'prop-types'
import routes from 'config/routes'
import Login from 'components/pages/login'
import Reset from 'components/pages/reset'
import ResetConfirm from 'components/pages/resetConfirm'
import AcceptInvitation from 'components/pages/general/acceptInvitation'
import CommunityInvitation from 'components/pages/communityInvitation'
import AboutUs from 'components/pages/public/aboutUs'
import CookiePolicy from 'components/pages/public/cookiePolicy'
import Contact from 'components/pages/public/contact'
import Privacy from 'components/pages/public/privacy'
import DashboardHome from 'components/pages/dashboard/dashboardHome'
import EventHome from 'components/pages/event/eventHome'
import EventParticipant from 'components/pages/event/eventParticipant'
import EventTicket from 'components/pages/event/eventTicket'
import EventAdmin from 'components/pages/event/eventAdmin'
import EventUpdate from 'components/pages/event/eventUpdate'
import VenueHome from 'components/pages/venue/venueHome'
import VenueSingle from 'components/pages/venue/venueSingle'
import VenueManage from 'components/pages/staff/venueManage'
import VenuesManage from 'components/pages/staff/venuesManage'
import VenueBookingDetail from 'components/pages/venue/bookingDetail/container'
import VenueBookingDetailPublic from 'components/pages/venue/bookingDetailPublic/container'
import BookingHome from 'components/pages/booking/bookingHome'
import BookingSingle from 'components/pages/booking/bookingSingle'
import BookingResult from 'components/pages/booking/bookingResult/view'
import BookingAdmin from 'components/pages/booking/bookingAdmin/view'
import BookingFind from 'components/pages/booking/bookingFind/view'
import Profile from 'components/pages/profile/profile/view'
import Error404 from 'components/pages/errors/error404'
import ErrorCommunity from 'components/pages/errors/errorCommunity'
import CommunitySingle from 'components/pages/community/communitySingle'
import CommunitySinglePublic from 'components/pages/community/communitySinglePublic'
import CommunityHome from 'components/pages/community/communityHome'
import CommunityExplore from 'components/pages/community/communityExplore'
import CommunityVenueHome from 'components/pages/community/venueSingle'
import CommunityBookingHome from 'components/pages/community/bookingSingle'
import CommunityManage from 'components/pages/community/communityManage'
import CommunityDetail from 'components/pages/staff/communityDetail'
import RequireAuth from './RequireAuth'
import Layout from 'components/template/layout'
import StaffList from 'components/pages/staff/staffList'
import StaffDetail from 'components/pages/staff/staffDetail'
import CommunitiesManage from 'components/pages/staff/communitiesManage'


const AppRoutes = props => {
  const { profile } = props
  const loggedIn = localStorage.getItem('token') && profile
  const navigate = useNavigate();

  const handleClickOnLink = (path) => {
    navigate(path);
  };

  return (
    <Routes>
      {loggedIn && (
        <Route
          path={routes.home}
          element={
            <RequireAuth layoutType='logged' breadcrumb>
              <Layout>
                {profile?.staff?.is_staff ? (
                  <VenuesManage />
                ) : (
                  <DashboardHome />
                )}
              </Layout>
            </RequireAuth>
          }
        />
      )}
      {!loggedIn && (
        <>
          <Route path={routes.home} element={
            <Layout hideFooterMargin={true}>
              <BookingFind />
            </Layout>
          } />
        </>
      )}
      <Route path={routes.aboutUs} element={
        <Layout>
          <AboutUs />
        </Layout>
      } />
      <Route path={routes.cookiePolicy} element={
        <Layout>
          <CookiePolicy />
        </Layout>
      } />
      <Route path={routes.contactUs} element={
        <Layout>
          <Contact />
        </Layout>
      } />
      <Route path={routes.login} element={
        <Layout>
          <Login />
        </Layout>
      } />
      <Route path={routes.signup} element={
        <Layout>
          <Login />
        </Layout>
      } />

      <Route path={routes.validateAccount} element={
        <Layout>
          <Login />
        </Layout>
      } />
      <Route path={routes.reset} element={
        <Layout>
          <Reset />
        </Layout>
      } />
      <Route path={routes.resetConfirm} element={
        <Layout>
          <ResetConfirm />
        </Layout>
      } />
      <Route path={routes.acceptInvitation} element={
        <Layout>
          <AcceptInvitation />
        </Layout>
      } />
      <Route path={routes.communityInvitation} element={
        <Layout>
          <CommunityInvitation />
        </Layout>
      } />
      <Route path={routes.terms} element={
        <Layout>
          <Privacy handleClickOnLink={handleClickOnLink} permitedUrls={{}} />
        </Layout>
      } />

      <Route path={routes.bookingFind} element={
        <Layout hideFooterMargin={true}>
          <BookingFind />
        </Layout>
      } />

      <Route
        path={routes.eventParticipant}
        element={
          <Layout>
            <EventParticipant />
          </Layout>
        }
      />
      <Route
        path={routes.eventTicket}
        element={
          <Layout>
            <EventTicket />
          </Layout>
        }
      />

      <Route
        path={routes.dashboard}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <DashboardHome />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.community}
        element={
          <Layout>
            <CommunitySingle />
          </Layout>
        }
      />
      <Route
        path={routes.communityPublic}
        element={
          <Layout>
            <CommunitySinglePublic />
          </Layout>
        }
      />
      <Route
        path={routes.communities}
        element={
          <Layout>
            {loggedIn ? <CommunityHome /> : <CommunityExplore />}
          </Layout>
        }
      />
      <Route
        path={routes.events}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <EventHome />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.eventUpdate}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <EventUpdate />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.venues}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <VenueHome />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.venue}
        element={
          loggedIn ? (
            <RequireAuth layoutType="logged" breadcrumb>
              <Layout>
                <VenueSingle />
              </Layout>
            </RequireAuth>
          ) : (
            <Layout>
              <VenueSingle />
            </Layout>
          )
        }
      />
      <Route
        path={routes.venueManage}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <VenueManage />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.venuesManage}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <VenuesManage />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.venueBookingDetail}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <VenueBookingDetail />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.venueBookingDetailPublic}
        element={
          <Layout>
            <VenueBookingDetailPublic />
          </Layout>
        }
      />
      <Route
        path={routes.staffsManage}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
                <StaffList />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.communitiesManage}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
                <CommunitiesManage />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.communityVenue}
        element={
          <Layout>
            <CommunityVenueHome />
          </Layout>
        }
      />
      <Route
        path={routes.communityBooking}
        element={
          <Layout>
            <CommunityBookingHome />
          </Layout>
        }
      />
      <Route
        path={routes.eventTicket}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <EventTicket />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.eventAdmin}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <EventAdmin />
            </Layout>
          </RequireAuth>
        }
      />
      <Route path={routes.bookingResult} element={
        <RequireAuth layoutType='logged' breadcrumb>
          <Layout>
            <BookingResult />
          </Layout>
        </RequireAuth>} />
      <Route
        path={routes.bookings}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <BookingHome />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.bookingAdmin}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <BookingAdmin />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.booking}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <BookingSingle />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.profile}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <Profile />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.communityManage}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <CommunityDetail />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.communityManageStaff}
        element={
          <RequireAuth layoutType='logged' breadcrumb>
            <Layout>
              <CommunityDetail />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path={routes.errorCommunity}
        element={
          <Layout>
            <ErrorCommunity />
          </Layout>
        }
      />
      <Route path='*' element={
        <Layout>
          <Error404 />
        </Layout>}
      />
    </Routes>
  );
}


AppRoutes.propTypes = {
  profile: PropTypes.object,
}

AppRoutes.defaultProps = {
  profile: null,
}

export default AppRoutes
